import React from 'react';

import LayoutProvider, { LayoutContext } from 'providers/Layout';
import DataLayerProvider, { DataLayerContext } from 'providers/DataLayer';
import Router from 'Router';
import { isLeader } from 'utils/ident';

const App = () => {
  if (isLeader) {
    document.documentElement.style.setProperty('--main-color', '#6c20e4');
    document.documentElement.style.setProperty('--main-color-2', '#6c20e4');
    document.documentElement.style.setProperty(
      '--color-primary-light',
      'rgba(108, 32, 228, 0.1)',
    );
  }
  return (
    <LayoutProvider>
      <LayoutContext.Consumer>
        {layout => (
          <DataLayerProvider>
            <DataLayerContext.Consumer>
              {data => <Router layout={layout} data={data} />}
            </DataLayerContext.Consumer>
          </DataLayerProvider>
        )}
      </LayoutContext.Consumer>
    </LayoutProvider>
  );
};

export default App;
